<template>
  <div class="rooms">
    <div class="college-header rooms-mobile-header">
      <div class="logos-row">
        <img class="college-logo-img" src="/assets/pomesto-logo.svg" alt="поместо" />
      </div>
      <nav class="desktop-nav" aria-label="Основное меню">
        <button type="button" aria-label="Моя комната" title="Моя комната" :disabled="!personalRoom" @click="openPersonalRoom">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m3 11 9-7 9 7M5.5 9.5V20h13V9.5M9.5 20v-6h5v6"/></svg>
          <span class="desktop-nav__label">Моя</span>
        </button>
        <button type="button" aria-label="Задания" title="Задания" @click="$emit('openTasks')">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h12a2 2 0 0 1 2 2v16H4V5a2 2 0 0 1 2-2Z"/><path d="m8 9 2 2 4-4M8 16h8"/></svg>
          <span class="desktop-nav__label">Задания</span>
          <span v-if="questRemaining" class="desktop-nav__badge">{{ questRemaining }}</span>
        </button>
        <button class="desktop-nav__item--active" type="button" aria-label="Комнаты" title="Комнаты" aria-current="page" @click="scrollRoomsTop">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z"/></svg>
          <span class="desktop-nav__label">Комнаты</span>
        </button>
        <button type="button" aria-label="Рюкзак" title="Рюкзак" @click="$emit('openBackpack')">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 7V5.8C8 3.7 9.6 2 12 2s4 1.7 4 3.8V7M7 22h10c2 0 3-1 3-3V10c0-2-1.1-3-3-3H7c-1.9 0-3 1-3 3v9c0 2 1 3 3 3Z"/><path d="M4 13h16M8 16h8"/></svg>
          <span class="desktop-nav__label">Рюкзак</span>
          <span v-if="unopenedCases" class="desktop-nav__badge">{{ unopenedCases }}</span>
        </button>
        <button type="button" aria-label="Магазин" title="Магазин" @click="$emit('openShop')">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8h16l-1 12H5L4 8Z"/><path d="M8 8V6a4 4 0 0 1 8 0v2M9 12h6"/></svg>
          <span class="desktop-nav__label">Магазин</span>
        </button>
      </nav>
      <div class="college-actions">
        <div class="header-coins" aria-label="Баланс монет">
          <span aria-hidden="true">●</span><strong>{{ coins }}</strong>
        </div>
        <button class="notifications-btn" type="button" aria-label="Открыть уведомления" title="Уведомления" @click="$emit('openNotifications')">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M9.7 21h4.6"/></svg>
          <span v-if="notificationUnread">{{ notificationUnread > 9 ? '9+' : notificationUnread }}</span>
        </button>
        <button class="feedback-btn" type="button" aria-label="Открыть обратную связь" title="Обратная связь" @click="$emit('openFeedback')">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16v12H8l-4 4V5Z"/><path d="M8 9h8m-8 4h5"/></svg>
        </button>
        <button v-if="adminRole" class="admin-btn" type="button" aria-label="Управление платформой" title="Управление платформой" @click="$emit('openAdmin')">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 4.5 6v5.2c0 4.8 3 8.1 7.5 9.8 4.5-1.7 7.5-5 7.5-9.8V6L12 3Z"/><path d="m9 12 2 2 4-5"/></svg>
        </button>
        <button class="character-btn" type="button" aria-label="Настроить персонажа" title="Настроить персонажа" @click="$emit('editCharacter')">
          <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4.5 21a7.5 7.5 0 0 1 15 0"/></svg>
          <span>Персонаж</span>
        </button>
      </div>
    </div>

    <div class="deco deco--star1" aria-hidden="true"></div>
    <div class="deco deco--star2" aria-hidden="true"></div>

    <div class="rooms__content">
      <div class="rooms__hero">
        <button class="back" aria-label="Назад" @click="$emit('back')" type="button">←</button>
        <div>
          <h1 class="rooms__title">Выбери своё место</h1>
          <p class="rooms__subtitle">Займись своим делом рядом с другими — спокойно и без лишнего шума.</p>
        </div>
      </div>

      <div class="rooms__panel">
        <div class="coins-chip">
          <span class="coins-chip__icon" aria-hidden="true">●</span>
          <span class="coins-chip__num">{{ coins }}</span>
          <span class="coins-chip__label">монет</span>
        </div>
        <button class="progress-btn" @click="$emit('openTasks')" type="button">
          Задания <span v-if="questRemaining">{{ questRemaining }}</span>
        </button>
        <button class="backpack-btn" @click="$emit('openBackpack')" type="button" aria-label="Открыть рюкзак" title="Рюкзак">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M8 7V5.8C8 3.7 9.6 2 12 2s4 1.7 4 3.8V7M7 22h10c2 0 3-1 3-3V10c0-2-1.1-3-3-3H7c-1.9 0-3 1-3 3v9c0 2 1 3 3 3Z"/>
            <path d="M4 13h16M8 16h8"/>
          </svg>
          <span v-if="unopenedCases">{{ unopenedCases }}</span>
        </button>
        <button class="edit-char-btn" @click="$emit('editCharacter')" type="button">
          Настроить персонажа
        </button>
        <ShopButton class="rooms__shop-btn" @click="$emit('openShop')" />
      </div>

      <div v-if="loading" class="rooms__loading">Загружаем комнаты…</div>
      <div v-else-if="loadError" class="rooms__error" role="alert">
        <strong>Комнаты пока не загрузились</strong>
        <span>Проверь соединение и попробуй ещё раз.</span>
        <button type="button" @click="load">Повторить</button>
      </div>
      <div v-else class="rooms__list">
        <button
          v-for="room in rooms"
          :key="room.id"
          class="room-card"
          :class="'room-card--' + room.roomType.toLowerCase()"
          :disabled="room.roomType !== 'PERSONAL' && room.humanOccupied >= room.capacity"
          @click="handlePick(room)"
          type="button"
        >
          <div class="room-card__icon"><RoomIcon :type="room.roomType" /></div>
          <div class="room-card__info">
            <h3>{{ room.title }}</h3>
            <p>{{ room.description }}</p>
            <span v-if="room.roomType === 'PERSONAL'" class="room-card__tag room-card__tag--personal">
              Только твоё · можно обустраивать
            </span>
            <span v-else-if="room.roomType === 'SOCIAL'" class="room-card__tag">
              5 минут в день бесплатно
            </span>
            <span v-else-if="room.roomType === 'CREATIVE'" class="room-card__tag room-card__tag--creative">
              Творческое пространство
            </span>
            <span v-else-if="room.roomType === 'COFFEE'" class="room-card__tag room-card__tag--coffee">
              Балийская кофейня
            </span>
            <span v-else-if="room.roomType === 'COWORK'" class="room-card__tag room-card__tag--cowork">
              Коворкинг · 4 переговорных
            </span>
            <span v-else-if="room.roomType === 'KPOP'" class="room-card__tag room-card__tag--kpop">
              K-pop · 12 мест
            </span>
          </div>
          <div class="room-card__badge">
            <span v-if="room.roomType !== 'PERSONAL'" class="room-card__count">{{ room.occupied }}<span class="room-card__cap"> / {{ room.capacity }}</span></span>
            <span class="room-card__label">
              {{ room.roomType === 'PERSONAL' ? "Открыть →" : room.humanOccupied >= room.capacity ? "Заполнено" : "Войти →" }}
            </span>
          </div>
        </button>
      </div>

      <button class="refresh" @click="load" type="button">↻ Обновить</button>
    </div>

    <!-- Rest modal -->
    <div v-if="restModalRoom" class="rest-modal" @click.self="restModalRoom = null">
      <div class="rest-modal__card">
        <div class="rest-modal__icon" aria-hidden="true">О</div>
        <h3>Комната отдыха</h3>
        <p v-if="restStatus">
          Свободное время сегодня: <strong>{{ fmt(restStatus.freeSecondsRemaining) }}</strong><br />
          Купленное время: <strong>{{ fmt(restStatus.paidSecondsRemaining) }}</strong>
        </p>
        <p v-else class="rest-modal__loading">Загружаем…</p>

        <div v-if="restStatus && restStatus.canEnter" class="rest-modal__actions">
          <button class="rest-modal__primary" @click="confirmEnterSocial" type="button">
            Войти
          </button>
          <button class="rest-modal__close" @click="restModalRoom = null" type="button">
            Позже
          </button>
        </div>
        <div v-else-if="restStatus" class="rest-modal__actions">
          <p class="rest-modal__warn">Время отдыха на сегодня закончилось. Возвращайся завтра.</p>
          <button class="rest-modal__close" @click="restModalRoom = null" type="button">
            Отмена
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue"
import { audioService } from "../shared/AudioService"
import RoomIcon from "./RoomIcon.vue"
import ShopButton from "./ShopButton.vue"
import type { RoomDto, RestStatusDto } from "../shared/types"
import { roomsListRoute } from "../api/rooms/list"
import { restStatusRoute } from "../api/rooms/restStatus"

const props = defineProps<{
  coins: number
  sessionId: string
  questRemaining?: number
  unopenedCases?: number
  notificationUnread?: number
  adminRole?: "owner" | "moderator" | null
}>()

const emit = defineEmits<{
  pick: [room: RoomDto]
  back: []
  editCharacter: []
  openShop: []
  coinsChanged: [coins: number]
  openTasks: []
  openBackpack: []
  openNotifications: []
  openFeedback: []
  openAdmin: []
}>()

const rooms = ref<RoomDto[]>([])
const loading = ref(true)
const loadError = ref(false)
const restModalRoom = ref<RoomDto | null>(null)
const restStatus = ref<RestStatusDto | null>(null)
const personalRoom = computed(() => rooms.value.find((room) => room.roomType === "PERSONAL") ?? null)

function openPersonalRoom() {
  if (personalRoom.value) handlePick(personalRoom.value)
}

function scrollRoomsTop() {
  document.querySelector(".rooms__content")?.scrollIntoView({ behavior: "smooth", block: "start" })
}

function fmt(totalSec: number) {
  const m = Math.floor(totalSec / 60)
  const s = totalSec % 60
  return `${m}:${String(s).padStart(2, "0")}`
}

async function load() {
  loading.value = true
  loadError.value = false
  try {
    const res = await roomsListRoute.run(ctx)
    rooms.value = res as RoomDto[]
  } catch (e) {
    rooms.value = []
    loadError.value = true
  } finally {
    loading.value = false
  }
}

async function handlePick(room: RoomDto) {
  if (room.roomType !== "PERSONAL" && room.humanOccupied >= room.capacity) return
  audioService.resume()
  if (room.roomType === "SOCIAL") {
    restModalRoom.value = room
    restStatus.value = null
    try {
      const res = await restStatusRoute.query({ sessionId: props.sessionId }).run(ctx)
      restStatus.value = res as RestStatusDto
    } catch (e) {}
    return
  }
  emit("pick", room)
}

async function confirmEnterSocial() {
  if (!restModalRoom.value) return
  audioService.resume()
  const r = restModalRoom.value
  restModalRoom.value = null
  emit("pick", r)
}

onMounted(load)
</script>

<style scoped>
/* ── Base ── */
.rooms {
  min-height: 100vh;
  background: #F6F2E9;
  font-family: "Inter", system-ui, -apple-system, sans-serif;
  color: #292B33;
  position: relative;
}

/* ── Decorations ── */
.deco {
  position: fixed;
  width: 84px;
  height: 84px;
  border: 16px solid rgba(98, 88, 217, 0.1);
  border-right: 0;
  border-bottom: 0;
  border-radius: 20px 0 0;
  pointer-events: none;
  user-select: none;
  opacity: 0.4;
  z-index: 0;
}
.deco--star1 { top: 20%; left: 3%; }
.deco--star2 { bottom: 18%; right: 4%; rotate: 180deg; }

/* ── College header ── */
.college-header {
  position: sticky;
  top: 0;
  z-index: 200;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 22px;
  padding: 10px 24px;
  background: rgba(255, 253, 248, 0.94);
  border-bottom: 1px solid rgba(41, 43, 51, 0.1);
  backdrop-filter: blur(14px);
}
.rooms-mobile-header { display: none; }
.college-logo-img {
  height: 32px;
  width: auto;
  display: block;
}
.logos-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.logo-divider {
  color: #6258D9;
  font-size: 20px;
  font-weight: 300;
  opacity: 0.4;
}
.college-badge {
  background: rgba(242, 184, 75, 0.2);
  color: #292B33;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  padding: 5px 12px;
  border-radius: 999px;
}
.desktop-nav {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.desktop-nav button,
.character-btn {
  position: relative;
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 13px;
  border: 0;
  border-radius: 14px;
  background: transparent;
  color: #666873;
  font: 750 13px/1 "Inter", system-ui, sans-serif;
  cursor: pointer;
  white-space: nowrap;
  transition: background .15s, color .15s, transform .15s;
}
.desktop-nav button:hover,
.character-btn:hover { background: #eeeaf8; color: #5147c4; }
.desktop-nav button:active,
.character-btn:active { transform: translateY(1px); }
.desktop-nav button:focus-visible,
.character-btn:focus-visible,
.notifications-btn:focus-visible,
.feedback-btn:focus-visible,
.admin-btn:focus-visible { outline: 3px solid #f2b84b; outline-offset: 2px; }
.desktop-nav button[disabled] { opacity: .45; cursor: wait; }
.desktop-nav svg,
.character-btn svg {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.desktop-nav__item--active {
  background: #6258d9 !important;
  color: #fff !important;
  box-shadow: 0 6px 18px rgba(98, 88, 217, .22);
}
.desktop-nav__badge {
  display: grid;
  min-width: 18px;
  height: 18px;
  place-items: center;
  padding: 0 5px;
  border-radius: 99px;
  background: #f2b84b;
  color: #292b33;
  font-size: 9px;
  font-weight: 900;
}
.college-actions { display: flex; align-items: center; justify-content: flex-end; gap: 8px; }
.header-coins {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid rgba(41, 43, 51, .08);
  border-radius: 14px;
  background: #fff;
  color: #6258d9;
  box-shadow: 0 4px 14px rgba(98, 88, 217, .09);
  font-size: 13px;
}
.header-coins span { color: #f2b84b; font-size: 16px; }
.character-btn { background: #fff; border: 1px solid rgba(41, 43, 51, .08); color: #5147c4; }
.notifications-btn { position:relative;display:grid;width:42px;height:42px;place-items:center;border:0;border-radius:14px;background:#eeeaf8;color:#6258d9;box-shadow:0 4px 14px rgba(98,88,217,.12);cursor:pointer }
.notifications-btn svg{width:23px;height:23px;fill:none;stroke:currentColor;stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round}
.notifications-btn span{position:absolute;top:-4px;right:-4px;display:grid;min-width:19px;height:19px;place-items:center;padding:0 4px;border:2px solid #fffdf8;border-radius:99px;background:#f2b84b;color:#292b33;font-size:9px;font-weight:900}
.feedback-btn{display:grid;width:42px;height:42px;place-items:center;border:1px solid rgba(41,43,51,.09);border-radius:14px;background:#fff;color:#6258d9;cursor:pointer}
.feedback-btn svg{width:22px;height:22px;fill:none;stroke:currentColor;stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round}
.admin-btn{display:grid;width:42px;height:42px;place-items:center;border:0;border-radius:14px;background:#292b33;color:#fff;box-shadow:0 4px 14px rgba(41,43,51,.16);cursor:pointer}
.admin-btn svg{width:22px;height:22px;fill:none;stroke:currentColor;stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round}

/* ── Content ── */
.rooms__content {
  max-width: 580px;
  margin: 0 auto;
  padding: 28px 16px 48px;
  position: relative;
  z-index: 1;
}

/* ── Hero ── */
.rooms__hero {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 20px;
}
.back {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  background: #fff;
  font-size: 20px;
  font-weight: 700;
  color: #6258D9;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 4px 14px rgba(98, 88, 217, 0.15);
  margin-top: 4px;
}
.rooms__title {
  margin: 0 0 4px;
  font-size: 32px;
  font-weight: 700;
  color: #292B33;
  text-transform: none;
  letter-spacing: -0.5px;
  line-height: 1.1;
}
.rooms__subtitle {
  margin: 0;
  color: #666873;
  font-weight: 500;
  font-size: 14px;
}

/* ── Panel: coins + edit ── */
.rooms__panel {
  display: none;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
  flex-wrap: wrap;
}
.coins-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(98, 88, 217, 0.12);
}
.coins-chip__icon { color: #f2b84b; font-size: 18px; }
.coins-chip__num {
  font-size: 18px;
  font-weight: 700;
  color: #6258D9;
}
.coins-chip__label {
  font-size: 12px;
  font-weight: 700;
  color: #666873;
  text-transform: none;
  letter-spacing: 0.5px;
}
.edit-char-btn {
  margin-left: 0;
  padding: 10px 16px;
  border-radius: 999px;
  border: none;
  background: #fff;
  color: #6258D9;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(98, 88, 217, 0.12);
  white-space: nowrap;
  font-family: "Inter", system-ui, sans-serif;
}
.progress-btn {
  position: relative;
  min-height: 44px;
  padding: 10px 15px;
  border: 0;
  border-radius: 999px;
  background: #eeeaf8;
  color: #5147c4;
  font: inherit;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
}
.progress-btn span {
  display: inline-grid;
  place-items: center;
  min-width: 20px;
  height: 20px;
  margin-left: 4px;
  padding: 0 5px;
  border-radius: 99px;
  background: #6258d9;
  color: white;
  font-size: 11px;
}
.backpack-btn {
  position: relative;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  border: 0;
  border-radius: 15px;
  background: #6258d9;
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(98, 88, 217, .2);
}
.backpack-btn svg {
  width: 23px;
  height: 23px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.backpack-btn span {
  position: absolute;
  top: -5px;
  right: -5px;
  display: grid;
  place-items: center;
  min-width: 19px;
  height: 19px;
  padding: 0 5px;
  border: 2px solid #f6f2e9;
  border-radius: 99px;
  background: #f2b84b;
  color: #292b33;
  font-size: 10px;
  font-weight: 900;
}
.rooms__shop-btn { margin-left: auto; min-height: 44px; }
/* ── Rooms list ── */
.rooms__list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.rooms__loading {
  text-align: center;
  padding: 40px;
  color: #6258D9;
  font-weight: 700;
  font-size: 16px;
}
.rooms__error {
  display: grid;
  gap: 8px;
  justify-items: start;
  padding: 24px;
  border: 1px solid rgba(98, 88, 217, 0.22);
  border-radius: 20px;
  background: #fffdf8;
  color: #666873;
}
.rooms__error strong { color: #292b33; }
.rooms__error button {
  min-height: 44px;
  margin-top: 4px;
  padding: 0 18px;
  border: 0;
  border-radius: 999px;
  background: #6258d9;
  color: white;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

/* ── Room card ── */
.room-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  border-radius: 20px;
  background: #FFFDF8;
  border: 1px solid rgba(41, 43, 51, 0.08);
  cursor: pointer;
  text-align: left;
  box-shadow: 0 10px 28px rgba(41, 43, 51, 0.07);
  transition: transform 0.15s, box-shadow 0.15s, border-color 0.15s;
  width: 100%;
  font-family: "Inter", system-ui, sans-serif;
}
.room-card:hover:not([disabled]) {
  transform: translateY(-3px);
  box-shadow: 0 16px 38px rgba(41, 43, 51, 0.11);
  border-color: #6258D9;
}
.room-card[disabled] {
  opacity: 0.45;
  cursor: not-allowed;
}
.room-card__icon {
  font-size: 18px;
  font-weight: 800;
  color: #292b33;
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: #E8E5F4;
  flex-shrink: 0;
}
.room-card--creative .room-card__icon {
  background: rgba(242, 184, 75, 0.22);
}
.room-card--personal {
  border-color: rgba(137, 184, 232, 0.55);
  background: linear-gradient(135deg, #FFFDF8 0%, #EEF5FB 100%);
}
.room-card--personal .room-card__icon {
  color: #3D6D9C;
  background: rgba(137, 184, 232, 0.28);
}
.room-card--social .room-card__icon {
  background: rgba(137, 184, 232, 0.24);
}
.room-card--coffee .room-card__icon {
  background: #FBF0D9;
}
.room-card--cowork .room-card__icon {
  background: #E8E5F4;
}
.room-card--kpop .room-card__icon {
  color: #5147c4;
  background: linear-gradient(145deg, #eeeaff, #f9e9c5);
}
.room-card__info {
  flex: 1;
  min-width: 0;
}
.room-card__info h3 {
  margin: 0 0 3px;
  font-size: 17px;
  font-weight: 700;
  color: #292B33;
}
.room-card__info p {
  margin: 0;
  font-size: 13px;
  color: #666873;
  font-weight: 600;
}
.room-card__tag {
  display: inline-block;
  margin-top: 5px;
  font-size: 11px;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0.4px;
  color: #6258D9;
  background: #E8E5F4;
  padding: 3px 8px;
  border-radius: 8px;
}
.room-card__tag--creative {
  color: #665018;
  background: rgba(242, 184, 75, 0.2);
}
.room-card__tag--personal {
  color: #3D6D9C;
  background: rgba(137, 184, 232, 0.2);
}
.room-card__tag--coffee {
  color: #a65a14;
  background: #FBF0D9;
}
.room-card__tag--cowork {
  color: #3b2fb8;
  background: #E8E5F4;
}
.room-card__tag--kpop {
  color: #5147c4;
  background: linear-gradient(90deg, #eeeaff, #fff1d6);
}
.room-card__badge {
  text-align: right;
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex-shrink: 0;
}
.room-card__count {
  font-size: 20px;
  font-weight: 700;
  color: #6258D9;
}
.room-card__cap {
  font-size: 14px;
  font-weight: 600;
  color: #666873;
}
.room-card__label {
  font-size: 11px;
  font-weight: 700;
  color: #6258D9;
  text-transform: none;
  letter-spacing: 0.5px;
}

/* ── Refresh ── */
.refresh {
  display: block;
  margin: 22px auto 0;
  padding: 10px 24px;
  border-radius: 999px;
  border: 2px solid rgba(98, 88, 217, 0.3);
  background: transparent;
  color: #6258D9;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  font-family: "Inter", system-ui, sans-serif;
  transition: background 0.15s;
}
.refresh:hover {
  background: rgba(255,255,255,0.5);
}

/* ── Rest modal ── */
.rest-modal {
  position: fixed;
  inset: 0;
  background: rgba(12, 30, 62, 0.6);
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  backdrop-filter: blur(6px);
}
.rest-modal__card {
  width: min(420px, 100%);
  background: #fff;
  border-radius: 24px;
  padding: 24px;
  box-shadow: 0 24px 60px rgba(98, 88, 217, 0.25);
}
.rest-modal__icon {
  font-size: 36px;
  margin-bottom: 8px;
}
.rest-modal__card h3 {
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 700;
  color: #6258D9;
  text-transform: none;
}
.rest-modal__card p {
  color: #666873;
  font-weight: 600;
  font-size: 14px;
}
.rest-modal__card strong {
  color: #292B33;
}
.rest-modal__loading {
  color: #666873;
}
.rest-modal__actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
}
.rest-modal__primary {
  padding: 14px;
  border-radius: 999px;
  border: none;
  background: #6258D9;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(98, 88, 217, 0.3);
  font-family: "Inter", system-ui, sans-serif;
}
.rest-modal__primary[disabled] {
  opacity: 0.45;
  cursor: not-allowed;
}
.rest-modal__secondary {
  padding: 12px;
  border-radius: 999px;
  border: 2px solid #E8E5F4;
  background: #FBF9F4;
  color: #6258D9;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  font-family: "Inter", system-ui, sans-serif;
}
.rest-modal__secondary[disabled] {
  opacity: 0.45;
  cursor: not-allowed;
}
.rest-modal__close {
  padding: 10px;
  border-radius: 999px;
  border: none;
  background: transparent;
  color: #666873;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  font-family: "Inter", system-ui, sans-serif;
}
.rest-modal__warn {
  color: #6258D9;
  font-weight: 700;
  background: #F0EEF9;
  padding: 10px 14px;
  border-radius: 12px;
}

@media (max-width: 767px) {
  .rooms-mobile-header { display:flex;justify-content:space-between;padding:14px 24px; }
  .desktop-nav, .header-coins, .character-btn { display:none; }
  .rooms__content { padding-bottom: calc(112px + env(safe-area-inset-bottom)); }
  .rooms__title { font-size: 26px; }
  .rooms__panel { display: grid; grid-template-columns: 1fr 1fr; }
  .coins-chip, .edit-char-btn { min-height: 44px; justify-content: center; width: 100%; }
  .progress-btn, .backpack-btn, .rooms__shop-btn { display: none; }
  .room-card--personal { display: none; }
  .college-badge { display: none; }
  .deco { display: none; }
}
@media (min-width: 768px) and (max-width: 1120px) {
  .college-header { gap: 12px; padding-inline: 16px; }
  .desktop-nav { gap: 2px; }
  .desktop-nav button { width: 44px; padding: 0; }
  .desktop-nav__label, .character-btn span { display: none; }
  .character-btn { width: 44px; padding: 0; }
}
</style>
